var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
import { Component } from '../framework/Component';
class Gallery {
    constructor(element) {
        this.htmlElement = element;
        $(this.htmlElement).find('.button-expend-gallery').on('click', (event, button) => {
            event.preventDefault();
            this.setHeight(($(this.htmlElement).hasClass('expended')) ? 'min' : 'max');
        });
    }
    setHeight(mode) {
        if (!$(this.htmlElement).hasClass('gallery-expendable'))
            return;
        var elementHeight = 0;
        if (mode == 'min') {
            elementHeight = $(this.htmlElement).find('.gallery-item').get(0).getBoundingClientRect().height;
            $(this.htmlElement).removeClass('expended');
        }
        else {
            elementHeight = $(this.htmlElement).find('.gallery-items').get(0).scrollHeight;
            $(this.htmlElement).addClass('expended');
        }
        let multiplier = (window.innerWidth < 768) ? 2 : 1;
        $(this.htmlElement).find('.gallery-items').get(0).style.maxHeight = (elementHeight * multiplier) + 'px';
        this.updateToggleGalleriesButton();
    }
    updateToggleGalleriesButton() {
        const expendableGalleries = $('.gallery-expendable').length;
        const expenedGalleries = $('.gallery-expendable.expended').length;
        if (expendableGalleries == expenedGalleries) {
            $('.button-toggle-galleries').addClass('opened');
        }
        else {
            $('.button-toggle-galleries').removeClass('opened');
        }
    }
}
export class GalleryComponent extends Component {
    constructor() {
        super('GalleryComponent', false);
        this.galleries = [];
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.module-gallery').forEach((gallery) => {
                this.galleries.push(new Gallery(gallery));
            });
            $('.button-toggle-galleries').on('click', (event, button) => {
                event.preventDefault();
                $(button).toggleClass('opened');
                const mode = $(button).hasClass('opened') ? 'max' : 'min';
                this.galleries.forEach((gallery) => {
                    gallery.setHeight(mode);
                });
            });
            var resizeTimeout;
            $(window).on('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = window.setTimeout(() => {
                    this.resizeGalleries();
                }, 500);
            });
            this.resizeGalleries();
            this.success();
        });
    }
    resizeGalleries() {
        this.galleries.forEach((gallery) => {
            gallery.setHeight('min');
        });
    }
}
